import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { subscribeFavoriteStoryIds, subscribeFinishedStoryIds } from "../data/storyRepo";
import { fetchAllStoryCards } from "../data/storyRepo";


import BrandBanner from "../components/layout/BrandBanner";
import StoriesRow from "../components/story/StoriesRow";

import "./MyLibrary.css";

export default function MyLibrary() {
  const { user } = useAuth();
  const [allStories, setAllStories] = useState([]);
  const [favoriteIDs, setFavoriteIDs] = useState([]);
  const [finishedIDs, setFinishedIDs] = useState([]);

  const language = "de"; // TEMP until you implement switchin

  // === LOAD ALL STORIES (same as Home) ===
  useEffect(() => {
    fetchAllStoryCards(language).then(setAllStories).catch(console.error);
  }, [language]); 

  // === LOAD FAVORITES ===
  useEffect(() => {
    if (!user?.uid) return;
  
    const unsubscribe = subscribeFavoriteStoryIds({
      uid: user.uid,
      language,
      onChange: setFavoriteIDs,
      onError: (err) => console.error("Error subscribing favorites:", err),
    });
  
    return unsubscribe;
  }, [user?.uid, language]);
  

  // === LOAD FINISHED STORIES ===
  useEffect(() => {
    if (!user?.uid) return;
  
    const unsubscribe = subscribeFinishedStoryIds({
      uid: user.uid,
      language,
      onChange: setFinishedIDs,
      onError: (err) => console.error("Error subscribing finished stories:", err),
    });
  
    return unsubscribe;
  }, [user?.uid, language]);
  

  // === MAP IDs → FULL STORY DATA ===
  const favoriteStories = allStories.filter((s) =>
    favoriteIDs.includes(s.id)
  );

  const finishedStories = allStories.filter((s) =>
    finishedIDs.includes(s.id)
  );

  const empty = favoriteStories.length === 0 && finishedStories.length === 0;

  return (
    <>
      <BrandBanner />

      <div className="library-container">
        <h1 className="library-title">Minha Biblioteca</h1>

        {!empty && (
          <>
            {favoriteStories.length > 0 && (
              <StoriesRow
                title={
                  <span className="library-row-title">
                    <FaHeart className="library-title-icon favorite" />
                    Favoritas
                  </span>
                }
                stories={favoriteStories}
              />
            )}

            {finishedStories.length > 0 && (
              <StoriesRow
                title={
                  <span className="library-row-title">
                    <FaCheckCircle className="library-title-icon finished" />
                    Concluídas
                  </span>
                }
                stories={finishedStories}
              />
            )}
          </>
        )}

        {empty && (
          <div className="library-empty">
            <p className="empty-title">Nada aqui ainda 😴</p>
            <p className="empty-subtitle">
              Leia uma história e marque como favorita ou concluída para vê-la aqui!
            </p>
          </div>
        )}
      </div>
    </>
  );
}
